import React, { createContext, useState, useContext, useEffect } from 'react';
import { initialChannels } from '../data/channels';

const ChannelContext = createContext();

export const useChannelContext = () => useContext(ChannelContext);

export const ChannelProvider = ({ children }) => {
  const [channels, setChannels] = useState([]);
  const [currentChannel, setCurrentChannel] = useState(null);
  const [currentFilter, setCurrentFilter] = useState('all');
  const [nextId, setNextId] = useState(100);

  // Load initial channels directly - no localStorage
  useEffect(() => {
    setChannels(initialChannels);
    const maxId = Math.max(...initialChannels.map(c => c.id), 0);
    setNextId(maxId + 1);
  }, []);

  // No localStorage saving - data stays in memory only

  const addChannel = (channel) => {
    const newChannel = { ...channel, id: nextId, viewers: 0 };
    setChannels(prev => [...prev, newChannel]);
    setNextId(prev => prev + 1);
    return newChannel;
  };

  const updateChannel = (id, updates) => {
    setChannels(prev => prev.map(ch => 
      ch.id === id ? { ...ch, ...updates } : ch
    ));
  };

  const deleteChannel = (id) => {
    setChannels(prev => prev.filter(ch => ch.id !== id));
    if (currentChannel?.id === id) {
      setCurrentChannel(null);
    }
  };

  const getFilteredChannels = () => {
    if (currentFilter === 'all') return channels;
    return channels.filter(ch => ch.cat === currentFilter);
  };

  const getLiveChannels = () => {
    return channels.filter(ch => ch.status === 'live');
  };

  const getWorldCupChannels = () => {
    return channels.filter(ch => ch.cat === 'worldcup');
  };

  const playChannel = (id) => {
    const ch = channels.find(c => c.id === id);
    if (ch) {
      setCurrentChannel(ch);
    }
  };

  return (
    <ChannelContext.Provider value={{
      channels,
      currentChannel,
      currentFilter,
      nextId,
      setCurrentFilter,
      addChannel,
      updateChannel,
      deleteChannel,
      getFilteredChannels,
      getLiveChannels,
      getWorldCupChannels,
      playChannel,
      setCurrentChannel
    }}>
      {children}
    </ChannelContext.Provider>
  );
};